import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { partitionCloneTags } from "helpers/tags";
import { TAG_MODEL_TYPE } from "routes/revenue_opportunity/form/constants";
import TagService from "services/Tag";

/**
 * The source tags a clone may carry. A non-Admin may only carry the tags they
 * could apply by hand; an Admin can apply every tag, so their clone keeps all.
 * `cloneTags` stays undefined until the decision is made, so the form never
 * mounts with the unfiltered source tags.
 */
export const useCloneTags = ({ isClone, isAdmin, sourceTags }) => {
  const filtersTags = isClone && !isAdmin;
  const { data: editableTags, isError } = useQuery({
    // Kept apart from the ["tags", model] key, whose initialData of [] would
    // read as loaded and drop every tag.
    queryKey: ["tags", TAG_MODEL_TYPE, "clone"],
    queryFn: () => TagService.getTags({ model: TAG_MODEL_TYPE }),
    enabled: filtersTags,
  });

  const partition = useMemo(
    () =>
      filtersTags && editableTags && sourceTags
        ? partitionCloneTags(sourceTags, editableTags)
        : null,
    [filtersTags, editableTags, sourceTags]
  );

  return {
    isPending: filtersTags && !partition && !isError,
    isError: filtersTags && isError,
    cloneTags: partition?.carriedTags,
    droppedTags: partition?.droppedTags ?? [],
  };
};
